<template>
  <div class="container-footer">
    Registros: {{ lengthElements }} de {{ totalElements }}
  </div>
</template>

<script>
export default {
  props: {
    lengthElements: {
      type: Number,
      default: 0,
    },
    totalElements: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style>
.container-footer {
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 0.5rem;
  font-size: 90%;
  background-color: rgba(0, 0, 0, 0.03);
}
</style>